import { CallRow } from "../../api/call/call.types";
import { CallListItem } from "./CallListItem";

export function CallList({
  items,
  selectedId,
  onSelect,
}: {
  items: CallRow[];
  selectedId?: string | null;
  onSelect?: (id: string) => void;
}) {
  return (
    <ul className="divide-y divide-cream-200">
      {items.map((item) => (
        <CallListItem
          key={item.id}
          item={item}
          isSelected={item.id === selectedId}
          onSelect={onSelect}
        />
      ))}
    </ul>
  );
}
